import styled from 'styled-components';

import { getSemanticValue } from '@freenow/wave';

export const FOOTER_HEIGHT = '65px';

export const FormFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: static;
    width: 100%;
    height: ${FOOTER_HEIGHT};
    padding: 0 2.5rem;
    border-top: 1px solid ${getSemanticValue('border-neutral-default')};
`;
